import React from 'react';
import classnames from 'classnames';
import { Icon } from '../icon';

import styles from './tag.module.scss';

export type TagProps = {
  label: string;
  appearance?: 'default' | 'lime';
  removable?: { onClick: () => void; ariaLabel: string };
  disabled?: boolean;
  className?: string;
};

const baseClass = 'tag';

export const Tag: React.FC<TagProps> = ({ label, removable, className, appearance = 'default', disabled }) => {
  const classes = classnames(
    styles.tag,
    styles[`${baseClass}--${appearance}`],
    { [styles[`${baseClass}--disabled`]]: disabled },
    className
  );
  return (
    <div className={classes} data-testid="tag-component">
      {removable && (
        <button
          disabled={disabled}
          onClick={removable.onClick}
          className={styles[`${baseClass}__button`]}
          aria-label={removable.ariaLabel}
        >
          <Icon name="close-without-circle--small" className={styles[`${baseClass}__icon`]} />
        </button>
      )}
      <span className={styles[`${baseClass}__label`]}>{label}</span>
    </div>
  );
};
